import React, {useEffect, useState } from "react";
import AlgebraKitQuestion from "./AlgebraKitQuestion";
import Tabs from "./Tabs";
import Tab from "./Tab";
import axios from "./axios";
import CircularLoader from "./CircularLoader";

const AlgebraKitBlock = props => {
    const {mediaId, callback} = props;

    const [exercises, setExercises] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [isError, setError] = useState(false);

    useEffect(() => {
        loadExercises();
    }, []);

    function loadExercises() {
        setLoading(true);
        axios.get("/web/media/akit/exercises/concept")
            .then(response => {
                setExercises(response.data);
                setLoading(false);
                if (typeof callback === 'function') callback();
            }).catch(error => {
            setError(true);
            setLoading(false);
            console.error('error', error);
        });
    }

    if (isLoading) {
        return <div><CircularLoader spacing={true}/></div>;
    }

    if (isError) {
        return <div>Error loading exercises. Please try again.</div>;
    }

    if (exercises == undefined || exercises.length == 0) {
        return <div>No exercises found.</div>;
    }

    return (
        <Tabs>
            {exercises.map((exercise, index) => (
                <Tab key={exercise.mediaId} children={<AlgebraKitQuestion mediaId={exercise.mediaId} exercise={exercise} />} tab={`Exercise ` + (index + 1)} />
            ))}
        </Tabs>
    )
}

export default AlgebraKitBlock;